import {
	ImporterFileStatus,
	ParserSubmissionStatus,
} from "../../common/files/files.module";
import {
	errorColor,
	primaryColor,
	successColor,
	warningColor,
} from "../../core/theme";

export function getTenderParserSubmissionColor(
	status?: ParserSubmissionStatus
) {
	switch (status) {
		case ParserSubmissionStatus.ERROR:
			return errorColor;
		case ParserSubmissionStatus.IN_PROGRESS:
			return warningColor;
		case ParserSubmissionStatus.DONE:
		case ParserSubmissionStatus.SUBMITTED:
			return successColor;
		case ParserSubmissionStatus.OUT_OF_DATE:
			return "#FFA500";
		default:
			return primaryColor;
	}
}

export function getFileImportStatusColor(status?: ImporterFileStatus) {
	switch (status) {
		case ImporterFileStatus.IMPORT_FAILED:
		case ImporterFileStatus.SITE_NOT_FOUND:
			return errorColor;
		case ImporterFileStatus.PENDING_IMPORT:
			return warningColor;
		case ImporterFileStatus.IMPORTED:
			return successColor;
		default:
			return primaryColor;
	}
}

export function getTenderParserSubmissionText(
	status?: ParserSubmissionStatus
): string {
	switch (status) {
		case ParserSubmissionStatus.ERROR:
			return "Error";
		case ParserSubmissionStatus.IN_PROGRESS:
			return "Pending";
		case ParserSubmissionStatus.SUBMITTED:
			return "Submitted";
		case ParserSubmissionStatus.OUT_OF_DATE:
			return "Out of date";
		case ParserSubmissionStatus.DONE:
			return "Processed";
		default:
			return "";
	}
}

export function getFileImporterText(status?: ImporterFileStatus): string {
	switch (status) {
		case ImporterFileStatus.IMPORTED:
			return "Imported";
		case ImporterFileStatus.IMPORT_FAILED:
			return "Import Failed";
		case ImporterFileStatus.PENDING_IMPORT:
			return "Pending Import";
		case ImporterFileStatus.SITE_NOT_FOUND:
			return "Site Not Found";
		default:
			return "";
	}
}
